import styled from 'styled-components';

export const FooterWrapper = styled.div`
  height: 75px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 1.2rem;
  font-style: italic;
  color: ${(props) => props.theme.secondaryColor};

  a {
    color: ${(props) => props.theme.secondaryColor};
    font-weight: bold;
    text-decoration: underline;
    &:hover {
      text-decoration: none;
    }
  }
`;
